import { html } from 'lit';

import { triggerAfsRequest } from '@client/google-afs';
import { events, messageBus } from '@schibsted-nmp/advertising-events';
import {
  AdServer,
  Afs,
  PlacementId,
  debugLog
} from '@schibsted-nmp/advertising-shared';

import { AdVendor } from './AdVendor';

export class AfsAdVendor extends AdVendor {
  placementId: PlacementId;

  constructor(placementId: PlacementId) {
    super();
    this.adServer = AdServer.AFS;
    this.placementId = placementId;
  }

  cleanupEvents(): void {}

  setupEvents(): void {
    this.cleanupEvents = messageBus.subscribe(
      events.PODLET.channel,
      events.PODLET.AFS_CONFIG.topic,
      (event) => {
        const { afs } = events.PODLET.AFS_CONFIG.getPayload(event);
        if (afs) {
          this.triggerAfsRequest(afs);
        }
      }
    );
  }

  private triggerAfsRequest(afs: Afs) {
    const styleId = afs.placements.find(
      (placement) => placement.container === this.placementId
    )?.styleId;
    if (!styleId) {
      debugLog(`No styleId found for container: ${this.placementId}`);
      return;
    }
    const afsPageOptions = {
      adPage: afs.adPage,
      pubId: afs.pubId,
      query: afs.query,
      styleId,
      number: 1
    };
    if (styleId) {
      triggerAfsRequest({
        container: this.placementId,
        ...afsPageOptions
      });
    }
  }

  requestAd(): void {
    // AFS is triggered by the config event listener, do nothing here
  }

  render() {
    return html`
      <slot
        name="${`${this.placementId}--slot`}"
        id="${this.placementId}"
      ></slot>
    `;
  }
}
